<template>
    <canvas ref="canvas" class="pointer-events-none fixed inset-0 w-full h-full" style="z-index: 100000" />
</template>

<script setup>
import { ref, onMounted } from 'vue';

const canvas = ref(null);

onMounted(() => {
    const el = canvas.value;
    if (!el) return;
    el.width = window.innerWidth;
    el.height = window.innerHeight;
    const ctx = el.getContext('2d');
    const colors = ['#DCC149', '#353CEE', '#FFB800', '#ff4f4f', '#4fff91', '#fff'];
    const pieces = Array.from({ length: 140 }, () => ({
        x: Math.random() * el.width,
        y: Math.random() * -el.height,
        w: 8 + Math.random() * 8,
        h: 14 + Math.random() * 8,
        color: colors[Math.floor(Math.random() * colors.length)],
        rot: Math.random() * Math.PI * 2,
        vx: (Math.random() - 0.5) * 3,
        vy: 2 + Math.random() * 4,
        vr: (Math.random() - 0.5) * 0.15,
        done: false,
    }));

    let frame;
    const draw = () => {
        ctx.clearRect(0, 0, el.width, el.height);
        let allDone = true;
        pieces.forEach(p => {
            if (p.done) return;
            p.x += p.vx;
            p.y += p.vy;
            p.rot += p.vr;
            if (p.y > el.height + p.h) { p.done = true; return; }
            allDone = false;
            ctx.save();
            ctx.translate(p.x, p.y);
            ctx.rotate(p.rot);
            ctx.fillStyle = p.color;
            ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
            ctx.restore();
        });
        if (!allDone) frame = requestAnimationFrame(draw);
        else ctx.clearRect(0, 0, el.width, el.height);
    };
    draw();

    return () => cancelAnimationFrame(frame);
});
</script>
